import {Component, Input, OnInit} from '@angular/core';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventServiceResponse, EventResponse} from '../../../../../../../../../../@shared/models/response.module';
import {_AQH_EVE_13} from '../../../../../../../../../../@shared/models/input.module';
import {ToastService} from '../../../../../../../../../../@core/services/toast.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-edit-event-service',
  standalone: false,
  templateUrl: './edit-event-service.html',
  styleUrl: './edit-event-service.css'
})
export class EditEventService implements OnInit {
  @Input() service: EventServiceResponse
  @Input() event: EventResponse

  vatRateOptions = [
    { value: 0, label: '0%' },
    { value: 12.5, label: '12.5%' },
    { value: 25, label: '25%' }
  ];

  currencyOptions = [
    { code: 'NOK', name: 'NOK' },
    { code: 'SEK', name: 'SEK' },
    { code: 'EUR', name: 'EUR' },
    { code: 'USD', name: 'USD' },
    { code: 'GBP', name: 'GBP' },
    { code: 'DKK', name: 'DKK' },
  ];

  submitted: boolean = false;
  saving: boolean = false;
  isFree: boolean = false;

  constructor(private eventService: EventsService,
              private modal: NgbActiveModal,
              private toastService: ToastService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    // Check if service is free (no price or price is 0)
    this.isFree = !this.service?.price || this.service.price === 0;

    // Set currency from event's default_currency (which was set during event creation)
    if (this.event?.default_currency) {
      this.service.price_currency = this.event.default_currency;
    }
  }

  toggleFree(checked: boolean) {
    this.isFree = checked;
    if (checked) {
      this.service.price = 0;
    }
  }

  // Validation helpers
  get isServiceNameInvalid(): boolean {
    return this.submitted && !this.service?.event_service_name?.trim();
  }

  get isFormValid(): boolean {
    return !!this.service?.event_service_name?.trim();
  }

  close() {
    this.modal.close();
  }

  saveChanges() {
    this.submitted = true;

    if (!this.isFormValid) {
      this.toastService.error(this.translateService.instant('manageEvent.editService.validationError'));
      return;
    }

    this.saving = true;

    let params: _AQH_EVE_13 = {
      event_id: this.service.event_id,
      event_service_id: this.service.event_service_id,
      event_service_name: this.service.event_service_name.trim(),
      event_service_description: this.service.event_service_description,
      max_num_registrations: this.service.max_num_registrations,
      price: this.service.price,
      price_currency: this.service.price_currency,
      vat_rate: this.service.vat_rate ?? 0
    }
    this.eventService.editEventService(params).subscribe({
      next: (res) => {
        this.saving = false;
        this.toastService.success(this.translateService.instant('manageEvent.editService.success'));
        this.modal.close(true);
      },
      error: (err) => {
        this.saving = false;
        this.toastService.error(err.error?.reason || this.translateService.instant('manageEvent.editService.error'));
      }
    });
  }

  /**
   * Calculate net amount after platform + payment fees
   * Stripe: 2.4% + 2.00 NOK, Platform: 2%
   * Net = price × 0.956 - 2.00
   */
  calculateNetAmount(price: number): number {
    if (!price || price <= 0) return 0;
    const net = price * 0.956 - 2;
    return Math.max(0, Math.round(net * 100) / 100);
  }

}
